const ONBOARDING_VERSION = "v1";
const ONBOARDING_KEY = `onboard:${ONBOARDING_VERSION}`;
const FIRST_RECORDING_KEY = `onboard:firstRecording:${ONBOARDING_VERSION}`;
const POST_STEP_SEEN_KEY = `onboard:postStepSeen:${ONBOARDING_VERSION}`;
export const DEFAULT_TEMPLATE_KEY = "onboard:defaultTemplate";

export const isOnboarded = (): boolean =>
  localStorage.getItem(ONBOARDING_KEY) === "true";

export const markOnboarded = (): void => {
  localStorage.setItem(ONBOARDING_KEY, "true");
};

export const isFirstRecordingDone = (): boolean =>
  localStorage.getItem(FIRST_RECORDING_KEY) === "true";

export const markFirstRecordingDone = (): void => {
  localStorage.setItem(FIRST_RECORDING_KEY, "true");
};

export const isPostStepSeen = (): boolean =>
  localStorage.getItem(POST_STEP_SEEN_KEY) === "true";

export const markPostStepSeen = (): void => {
  localStorage.setItem(POST_STEP_SEEN_KEY, "true");
};
